__turbopack_context__.v({
  "listing_modal": "tHzhfW_listing_modal",
  "listing_modal__channel_text": "tHzhfW_listing_modal__channel_text",
  "listing_modal__close_btn": "tHzhfW_listing_modal__close_btn",
  "listing_modal__duration": "tHzhfW_listing_modal__duration",
  "listing_modal__episode_description": "tHzhfW_listing_modal__episode_description",
  "listing_modal__episode_title": "tHzhfW_listing_modal__episode_title",
  "listing_modal__inner": "tHzhfW_listing_modal__inner",
  "listing_modal__logo": "tHzhfW_listing_modal__logo",
  "listing_modal__progress": "tHzhfW_listing_modal__progress",
  "listing_modal__progress_bar": "tHzhfW_listing_modal__progress_bar",
  "listing_modal__show_title": "tHzhfW_listing_modal__show_title",
  "listing_modal__time_remaining": "tHzhfW_listing_modal__time_remaining",
  "listing_modal__watch_btn": "tHzhfW_listing_modal__watch_btn",
});
